// Sistema de reseñas Skull Hearts - Versión mejorada sin scroll automático
document.addEventListener('DOMContentLoaded', function() {
  // Referencias DOM
  const writeReviewBtn = document.getElementById('writeReviewBtn');
  const reviewFormWrapper = document.getElementById('reviewFormWrapper');
  const closeFormBtn = document.getElementById('closeFormBtn');
  const reviewForm = document.getElementById('productReviewForm');
  const sortSelect = document.getElementById('sortReviews');
  const reviewsList = document.getElementById('reviewsList');
  const averageRatingElement = document.querySelector('.rating-number');
  const totalReviewsElement = document.querySelector('.total-reviews');
  const ratingBarsContainer = document.querySelector('.rating-breakdown');
  const paginationControls = document.getElementById('paginationControls');
  const prevPageBtn = document.getElementById('prevPage');
  const nextPageBtn = document.getElementById('nextPage');
  const currentPageElement = document.getElementById('currentPage');
  const totalPagesElement = document.getElementById('totalPages');
  
  // URLs de las APIs
  const SAVE_API_URL = 'https://skullhearts-theme.vercel.app/api/save-review';
  const GET_API_URL = 'https://skullhearts-theme.vercel.app/api/get-reviews';
  
  // Estado global
  let currentReviews = [];
  let currentProductId = null;
  let currentPage = 1;
  const reviewsPerPage = 5;
  let selectedPhotos = [];
  let isInitialLoad = true; // Flag para controlar la carga inicial

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
  
  // Inicializar sistema
  init();
  
  async function init() {
    currentProductId = getProductId();
    
    if (currentProductId) {
      await loadReviews();
    }
    
    setupEventListeners();
    isInitialLoad = false; // Después de la carga inicial
  }
  
  function getProductId() {
    // Obtener handle desde URL
    const pathParts = window.location.pathname.split('/');
    const productHandle = pathParts[pathParts.length - 1];
    
    if (productHandle && productHandle !== 'products' && !/^\d+$/.test(productHandle)) {
      return productHandle;
    }
    
    // Fallback: obtener desde data attribute
    const productElement = document.querySelector('[data-product-handle]');
    if (productElement && productElement.dataset.productHandle) {
      return productElement.dataset.productHandle;
    }
    
    return null;
  }
  
  async function loadReviews(forceRefresh = false) {
    try {
      let url = `${GET_API_URL}?productHandle=${encodeURIComponent(currentProductId)}`;
      
      // Añadir parámetro nocache si se fuerza la actualización
      if (forceRefresh) {
        url += '&nocache=true';
      }
      
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const result = await response.json();
      
      if (result.success && result.data) {
        currentReviews = result.data.reviews;
        sortReviews('recent');
        updateStatistics(result.data.statistics);
      } else {
        displayNoReviews();
      }
      
    } catch (error) {
      window.Shopify && window.Shopify.designMode && console.error('Error loading reviews:', error);
      displayNoReviews();
    }
  }
  
  function sortReviews(sortType) {
    const sortedReviews = [...currentReviews];
    
    switch (sortType) {
      case 'recent':
        sortedReviews.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        break;
      case 'rating-high':
        sortedReviews.sort((a, b) => b.rating - a.rating);
        break;
      case 'rating-low':
        sortedReviews.sort((a, b) => a.rating - b.rating);
        break;
      case 'with-photos':
        sortedReviews.sort((a, b) => {
          const aPhotos = a.photos?.length || 0;
          const bPhotos = b.photos?.length || 0;
          return bPhotos - aPhotos;
        });
        break;
    }
    
    currentReviews = sortedReviews;
    currentPage = 1;
    displayReviewsPage();
  }
  
  function displayReviewsPage() {
    if (!reviewsList) return;
    
    reviewsList.classList.add('loading');
    
    setTimeout(() => {
      if (currentReviews.length === 0) {
        displayNoReviews();
        paginationControls.style.display = 'none';
        reviewsList.classList.remove('loading');
        return;
      }
      
      const totalPages = Math.ceil(currentReviews.length / reviewsPerPage);
      const startIndex = (currentPage - 1) * reviewsPerPage;
      const endIndex = startIndex + reviewsPerPage;
      const pageReviews = currentReviews.slice(startIndex, endIndex);
      
      const reviewsHTML = pageReviews.map((review, index) => 
        createReviewElement(review, startIndex + index)
      ).join('');
      
      reviewsList.innerHTML = reviewsHTML;
      reviewsList.classList.remove('loading');
      
      // Actualizar paginación
      if (totalPages > 1) {
        paginationControls.style.display = 'flex';
        currentPageElement.textContent = currentPage;
        totalPagesElement.textContent = totalPages;
        
        prevPageBtn.disabled = currentPage === 1;
        nextPageBtn.disabled = currentPage === totalPages;
      } else {
        paginationControls.style.display = 'none';
      }
      
      // Configurar lightbox para fotos
      setupPhotoLightbox();
      
      // ELIMINADO: No hacer scroll automático
      // Solo mantener el foco visual sin mover la página
      
    }, 300);
  }
  
  function displayNoReviews() {
    if (!reviewsList) return;
    
    reviewsList.innerHTML = `
      <div class="no-reviews">
        <p>Aún no hay reseñas para este producto.</p>
        <p>¡Sé el primero en compartir tu experiencia!</p>
      </div>
    `;
  }
  
  function updateStatistics(stats) {
    if (!stats) return;
    
    if (averageRatingElement) {
      averageRatingElement.textContent = stats.averageRating || '0.0';
    }
    
    if (totalReviewsElement) {
      const text = stats.totalReviews === 1 
        ? `Basado en ${stats.totalReviews} reseña`
        : `Basado en ${stats.totalReviews} reseñas`;
      totalReviewsElement.textContent = text;
    }
    
    // Actualizar contador
    const reviewsCount = document.querySelector('.reviews-count');
    if (reviewsCount) {
      reviewsCount.textContent = stats.totalReviews === 1 
        ? `${stats.totalReviews} reseña`
        : `${stats.totalReviews} reseñas`;
    }
    
    // Actualizar barras de rating
    if (ratingBarsContainer && stats.ratingDistribution) {
      updateRatingBars(stats.ratingDistribution);
    }
    
    // Actualizar estadísticas adicionales
    const photoCount = document.getElementById('photoCount');
    if (photoCount) {
      const withPhotos = stats.withPhotos || currentReviews.filter(r => r.photos && r.photos.length > 0).length;
      
      // Animación de contador
      let current = 0;
      const target = withPhotos;
      const duration = 1000; // 1 segundo
      const increment = target / (duration / 50);
      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          current = target;
          clearInterval(timer);
        }
        photoCount.textContent = Math.floor(current);
      }, 50);
    }
  }
  
  function updateRatingBars(distribution) {
    distribution.forEach(item => {
      const progressBar = document.querySelector(`.rating-bar:nth-child(${6 - item.rating}) .progress-fill`);
      if (progressBar) {
        progressBar.style.width = `${item.percentage}%`;
      }
      const countElement = document.querySelector(`.rating-bar:nth-child(${6 - item.rating}) .count`);
      if (countElement) {
        countElement.textContent = item.count;
      }
    });
  }
  
  function setupEventListeners() {
    // Formulario - buscar botón con ambas clases posibles
    const writeReviewBtn = document.getElementById('writeReviewBtn') || document.querySelector('.write-review-btn-enhanced');
    if (writeReviewBtn) {
      writeReviewBtn.addEventListener('click', () => {
        reviewFormWrapper.style.display = 'block';
        // Scroll suave solo al abrir el formulario
        setTimeout(() => {
          reviewFormWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
      });
    }
    
    if (closeFormBtn) {
      closeFormBtn.addEventListener('click', () => {
        reviewFormWrapper.style.display = 'none';
        resetForm();
      });
    }
    
    // Contador de caracteres
    const textarea = document.querySelector('textarea[name="review_text"]');
    const charCounter = document.querySelector('.char-count');
    if (textarea && charCounter) {
      textarea.addEventListener('input', function() {
        const length = this.value.length;
        charCounter.textContent = length;
        
        const counterElement = charCounter.parentElement;
        counterElement.classList.remove('warning', 'error');
        
        if (length > 450) {
          counterElement.classList.add('warning');
        }
        if (length > 500) {
          counterElement.classList.add('error');
          this.value = this.value.substring(0, 500);
          charCounter.textContent = 500;
        }
      });
    }
    
    // Paginación
    if (prevPageBtn) {
      prevPageBtn.addEventListener('click', () => {
        if (currentPage > 1) {
          currentPage--;
          displayReviewsPage();
        }
      });
    }
    
    if (nextPageBtn) {
      nextPageBtn.addEventListener('click', () => {
        const totalPages = Math.ceil(currentReviews.length / reviewsPerPage);
        if (currentPage < totalPages) {
          currentPage++;
          displayReviewsPage();
        }
      });
    }
    
    // Setup otros handlers
    setupStarRating();
    setupPhotoUpload();
    setupFormSubmission();
    
    // Ordenamiento
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        sortReviews(this.value);
      });
    }
  }
  
  function setupStarRating() {
    const starRating = document.querySelector('.star-rating-input');
    if (!starRating) return;
    
    const stars = starRating.querySelectorAll('.star-input');
    const ratingInput = document.getElementById('ratingValue');
    
    stars.forEach((star, index) => {
      star.addEventListener('click', () => {
        const rating = index + 1;
        starRating.setAttribute('data-rating', rating);
        if (ratingInput) ratingInput.value = rating;
        
        stars.forEach((s, i) => {
          s.classList.toggle('active', i < rating);
        });
      });
      
      star.addEventListener('mouseenter', () => {
        stars.forEach((s, i) => {
          s.classList.toggle('hover', i <= index);
        });
      });
    });
    
    starRating.addEventListener('mouseleave', () => {
      stars.forEach(s => s.classList.remove('hover'));
    });
  }
  
  function setupPhotoUpload() {
    const photoInput = document.getElementById('photoInput');
    const photoLabel = document.querySelector('.photo-upload-label');
    const photoPreview = document.getElementById('photoPreview');
    
    if (!photoInput || !photoLabel) return;
    
    photoLabel.addEventListener('dragover', (e) => {
      e.preventDefault();
      photoLabel.classList.add('drag-over');
    });
    
    photoLabel.addEventListener('dragleave', () => {
      photoLabel.classList.remove('drag-over');
    });
    
    photoLabel.addEventListener('drop', (e) => {
      e.preventDefault();
      photoLabel.classList.remove('drag-over');
      handleFiles(e.dataTransfer.files);
    });
    
    photoInput.addEventListener('change', (e) => {
      handleFiles(e.target.files);
    });
    
    function handleFiles(files) {
      selectedPhotos = [];
      photoPreview.innerHTML = '';
      
      const validFiles = Array.from(files).slice(0, 3).filter(file => {
        if (!file.type.startsWith('image/')) {
          showMessage('Solo se permiten archivos de imagen', 'error');
          return false;
        }
        if (file.size > 5 * 1024 * 1024) { // 5MB
          showMessage(`${file.name} es muy grande (máx 5MB)`, 'error');
          return false;
        }
        return true;
      });
      
      validFiles.forEach((file, index) => {
        const reader = new FileReader();
        
        reader.onload = function(e) {
          selectedPhotos.push(e.target.result);
          
          const preview = document.createElement('div');
          preview.className = 'photo-preview-item';
          preview.innerHTML = `
            <img src="${e.target.result}" alt="Preview ${index + 1}">
            <button type="button" class="remove-photo" data-index="${index}">✕</button>
          `;
          
          photoPreview.appendChild(preview);
          
          // Botón eliminar
          preview.querySelector('.remove-photo').addEventListener('click', function() {
            const idx = parseInt(this.dataset.index);
            selectedPhotos.splice(idx, 1);
            photoInput.value = '';
            updatePhotoPreview();
          });
        };
        
        reader.readAsDataURL(file);
      });
      
      updateUploadLabel();
    }
    
    function updatePhotoPreview() {
      photoPreview.innerHTML = '';
      selectedPhotos.forEach((photo, index) => {
        const preview = document.createElement('div');
        preview.className = 'photo-preview-item';
        preview.innerHTML = `
          <img src="${photo}" alt="Preview ${index + 1}">
          <button type="button" class="remove-photo" data-index="${index}">✕</button>
        `;
        photoPreview.appendChild(preview);
        
        preview.querySelector('.remove-photo').addEventListener('click', function() {
          const idx = parseInt(this.dataset.index);
          selectedPhotos.splice(idx, 1);
          updatePhotoPreview();
          updateUploadLabel();
        });
      });
    }
    
    function updateUploadLabel() {
      const uploadText = document.querySelector('.upload-text');
      if (uploadText) {
        if (selectedPhotos.length > 0) {
          uploadText.textContent = `${selectedPhotos.length} foto${selectedPhotos.length > 1 ? 's' : ''} seleccionada${selectedPhotos.length > 1 ? 's' : ''}`;
        } else {
          uploadText.innerHTML = '<span class="upload-icon">📸</span> Arrastra fotos aquí o haz clic para seleccionar';
        }
      }
    }
  }
  
  function setupFormSubmission() {
    if (!reviewForm) return;
    
    reviewForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      const submitBtn = this.querySelector('.submit-review-btn');
      
      // Validaciones
      const rating = formData.get('rating');
      if (!rating || rating === '0') {
        showMessage('Por favor, selecciona una calificación', 'error');
        return;
      }
      
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.get('customer_email'))) {
        showMessage('Por favor, introduce un email válido', 'error');
        return;
      }
      
      const comment = formData.get('review_text');
      if (!comment || comment.trim().length < 10) {
        showMessage('El comentario debe tener al menos 10 caracteres', 'error');
        return;
      }
      
      // UI feedback
      submitBtn.disabled = true;
      submitBtn.textContent = 'Publicando...';
      
      const reviewData = {
        productId: currentProductId,
        customerName: formData.get('customer_name'),
        customerEmail: formData.get('customer_email'),
        rating: parseInt(rating),
        comment: comment,
        productHandle: currentProductId,
        createdAt: new Date().toISOString()
      };
      
      // Solo añadir fotos si hay alguna seleccionada
      if (selectedPhotos.length > 0) {
        reviewData.photos = selectedPhotos;
      }
      
      try {
        const response = await fetch(SAVE_API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(reviewData)
        });
        
        const result = await response.json();
        
        if (!response.ok) {
          throw new Error(result.error || `Error: ${response.status}`);
        }
        
        // Éxito
        resetForm();
        reviewFormWrapper.style.display = 'none';
        
        if (result.photosUploaded && result.photosUploaded > 0) {
          showSuccessMessage(`¡Reseña publicada con éxito! (${result.photosUploaded} fotos)`);
        } else {
          showSuccessMessage('¡Reseña publicada con éxito!');
        }
        
        // Volver al top de las reseñas sin hacer scroll automático
        currentPage = 1;
        
        setTimeout(async () => {
          await loadReviews(true); // Forzar actualización sin cache
        }, 1000);
        
      } catch (error) {
        showMessage(error.message || 'Error al publicar la reseña', 'error');
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Publicar reseña';
      }
    });
  }
  
  function resetForm() {
    reviewForm.reset();
    
    // Reset estrellas
    const starRating = document.querySelector('.star-rating-input');
    if (starRating) {
      starRating.setAttribute('data-rating', '0');
      document.querySelectorAll('.star-input').forEach(s => s.classList.remove('active'));
    }
    
    // Reset fotos
    selectedPhotos = [];
    const photoPreview = document.getElementById('photoPreview');
    if (photoPreview) photoPreview.innerHTML = '';
    
    const uploadText = document.querySelector('.upload-text');
    if (uploadText) {
      uploadText.innerHTML = '<span class="upload-icon">📸</span> Arrastra fotos aquí o haz clic para seleccionar';
    }
    
    // Reset contador
    const charCounter = document.querySelector('.char-count');
    if (charCounter) charCounter.textContent = '0';
  }
  
  function createReviewElement(data, index) {
    const rating = Math.max(0, Math.min(5, Number(data.rating) || 0));
    const customerNameText = String(data.customerName ?? '');
    const safeCustomerName = escapeHtml(customerNameText);
    const safeComment = escapeHtml(data.comment ?? '');

    const stars = Array(5)
      .fill('')
      .map((_, i) => `<span class="star ${i < rating ? 'filled' : ''}">★</span>`)
      .join('');
    
    const date = new Date(data.createdAt).toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    
    const verifiedBadge = data.verified 
      ? '<span class="verified-badge">✓ Compra verificada</span>' 
      : '';
    
    // Crear galería de fotos si existen
    let photosHtml = '';
    const photos = Array.isArray(data.photos) ? data.photos : [];
    if (photos.length > 0) {
      photosHtml = `
        <div class="review-photos">
          ${photos.map((photo, photoIndex) => {
            const photoUrl = typeof photo === 'string' ? photo : photo?.url;
            const safePhotoUrl = escapeHtml(photoUrl ?? '');
            const safeAlt = escapeHtml(`Foto ${photoIndex + 1} de ${customerNameText}`);

            return `
            <div class="review-photo-thumb" data-photo="${safePhotoUrl}" data-index="${photoIndex}">
              <img src="${safePhotoUrl}" alt="${safeAlt}">
            </div>
          `;
          }).join('')}
        </div>
      `;
    }
    
    const animationDelay = (index % reviewsPerPage) * 0.1;
    
    return `
      <div class="review-item" style="animation-delay: ${animationDelay}s">
        <div class="review-header">
          <div class="reviewer-info">
            <span class="reviewer-name">${safeCustomerName}</span>
            ${verifiedBadge}
          </div>
          <div class="review-rating">${stars}</div>
        </div>
        <div class="review-content">
          <p>${safeComment}</p>
        </div>
        ${photosHtml}
        <div class="review-footer">
          <span class="review-date">${date}</span>
          ${data.featured ? '<span class="featured-badge">⭐ Destacada</span>' : ''}
        </div>
      </div>
    `;
  }
  
  function setupPhotoLightbox() {
    const photoThumbs = document.querySelectorAll('.review-photo-thumb');
    
    photoThumbs.forEach(thumb => {
      thumb.addEventListener('click', function() {
        const photoUrl = this.dataset.photo;
        const lightbox = createLightbox(photoUrl);
        document.body.appendChild(lightbox);
        
        setTimeout(() => lightbox.classList.add('active'), 10);
      });
    });
  }
  
  function createLightbox(photoUrl) {
    const lightbox = document.createElement('div');
    lightbox.className = 'photo-lightbox';
    const safePhotoUrl = escapeHtml(photoUrl ?? '');
    lightbox.innerHTML = `
      <div class="lightbox-content">
        <button class="lightbox-close">✕</button>
        <img src="${safePhotoUrl}" alt="Foto ampliada">
      </div>
    `;
    
    // Cerrar al hacer clic fuera
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) {
        closeLightbox(lightbox);
      }
    });
    
    // Cerrar con botón
    lightbox.querySelector('.lightbox-close').addEventListener('click', () => {
      closeLightbox(lightbox);
    });
    
    // Cerrar con ESC
    document.addEventListener('keydown', function escHandler(e) {
      if (e.key === 'Escape') {
        closeLightbox(lightbox);
        document.removeEventListener('keydown', escHandler);
      }
    });
    
    return lightbox;
  }
  
  function closeLightbox(lightbox) {
    lightbox.classList.remove('active');
    setTimeout(() => lightbox.remove(), 300);
  }
  
  function showSuccessMessage(text) {
    const message = document.createElement('div');
    message.className = 'success-message';
    message.textContent = text;
    document.body.appendChild(message);
    
    setTimeout(() => {
      message.remove();
    }, 5000);
  }
  
  function showMessage(text, type = 'info') {
    const existingMessage = document.querySelector('.form-message');
    if (existingMessage) {
      existingMessage.remove();
    }
    
    const message = document.createElement('div');
    message.className = `form-message ${type}`;
    const safeText = escapeHtml(text ?? '');
    message.innerHTML = `
      <span class="message-icon">${type === 'success' ? '✓' : type === 'error' ? '⚠' : 'ℹ'}</span>
      <span class="message-text">${safeText}</span>
    `;
    
    const form = document.getElementById('productReviewForm');
    if (form && form.parentNode) {
      form.parentNode.insertBefore(message, form.nextSibling);
    }
    
    setTimeout(() => {
      if (message.parentNode) {
        message.remove();
      }
    }, 5000);
  }
});
